import React from 'react';

import './style.scss';

const ComingSoon = () => (
    <div className="coming-soon">
        <h1>Coming Soon</h1>
    </div>
)
export default ComingSoon;